import React, { useEffect, useState, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Box, CircularProgress } from "@material-ui/core"
import _ from "lodash"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { Link, useLocation } from "react-router-dom"
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout"
import { zoomPlugin } from "@react-pdf-viewer/zoom"
import { toolbarPlugin, ToolbarSlot } from "@react-pdf-viewer/toolbar"
import { AnnotationType, Viewer, Worker, createStore, PluginFunctions, Button, Tooltip, Position } from "@react-pdf-viewer/core"
//import { FlagKeyword, NextIcon, PreviousIcon, searchPlugin } from "@react-pdf-viewer/search"
import { FlagKeyword, NextIcon, PreviousIcon, searchPlugin } from "../../common/search/lib/cjs/search"
import { NativeHeader } from "../../../components/viewer"
import axios from "../../../services/axios"
import { addAnnotation, updateViewerPageNumber } from "../../../actions/viewerActions"
import { highlightPlugin, HighlightArea, RenderHighlightTargetProps, MessageIcon, RenderHighlightsProps } from "@react-pdf-viewer/highlight"
import "@react-pdf-viewer/core/lib/styles/index.css"
import "@react-pdf-viewer/search/lib/styles/index.css"
import "@react-pdf-viewer/default-layout/lib/styles/index.css"
import "@react-pdf-viewer/search/lib/styles/index.css"
import "@react-pdf-viewer/core/lib/styles/index.css"
import "@react-pdf-viewer/zoom/lib/styles/index.css"
import "@react-pdf-viewer/toolbar/lib/styles/index.css"
import "@react-pdf-viewer/highlight/lib/styles/index.css"
import { gridColumnLookupSelector } from "@mui/x-data-grid"
import { MinimalButton, Spinner, TextBox } from "@react-pdf-viewer/core"
import { Match, RenderSearchProps } from "@react-pdf-viewer/search"
const useStyles = makeStyles((theme) => ({
	root: {
		...theme.typography.body2,
		backgroundColor: theme.palette.common.white,
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
		marginBottom: "20px",
		height: "70vh",
		"& .rpv-search__highlight--current": {
			//backgroundColor: "transparent",
			//outline: "thick ridge pink",
		},
	},
}))

const NativeView = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const theme = useTheme()
	const [t] = useTranslation("global")
	const location = useLocation()
	const [source, setSource] = useState("")
	const [highlightMultipleWords, setHighlightMultipleWords] = useState("")
	const { currentPageNumber, annotations } = useSelector((state) => state.viewerData)
	const annotationStatus = useSelector((state) => state.highlightFilter.annotation)
	const highlightFilter = useSelector((state) => state.highlightFilter.search)
	const [base64, setBase64] = useState(false)
	const { documentDetails } = props

	//TODO: This code is for highlight words it multiple colors

	// const searchPluginInstance = searchPlugin({
	// 	onHighlightKeyword: (props) => {
	// 		if (highlightFilter?.loadedConcept?.includes(props.keyword.source?.trim())) {
	// 			props.highlightEle.style.backgroundColor = "rgba(203, 194, 246, .5)"
	// 		}

	// 		if (documentDetails?.metadata?.emails?.includes(props?.keyword?.source?.replaceAll("\\", "").trim())) {
	// 			props.highlightEle.style.backgroundColor = "rgba(168, 224, 245, .5)"
	// 		}

	// 		if (documentDetails?.metadata?.dates?.includes(props?.keyword?.source?.replaceAll("\\", "").trim())) {
	// 			props.highlightEle.style.backgroundColor = "rgba(255, 194, 137, .5)"
	// 		}

	// 		if (highlightFilter?.searchWord) {
	// 			if (highlightFilter?.searchWord?.includes(props.keyword.source)) {
	// 				props.highlightEle.style.backgroundColor = "rgba(253, 237, 154, .5)"
	// 			}
	// 		}
	// 	},
	// })
	const searchPluginInstance = searchPlugin()

	const { ShowSearchPopoverButton, highlight, jumpToNextMatch, jumpToPreviousMatch, Search } = searchPluginInstance

	const customAnnotationPlugin = () => {
		const onAnnotationLayerRender = (e) => {
			// Find all `Link` annotation
			e.annotations
				.filter((annotation) => annotation.annotationType === AnnotationType.Link)
				.forEach((annotation) => {
					if (annotation.url) {
						// Find the `a` element represents the link
						;[...e.container.querySelectorAll(".rpv-core__annotation--link a")].forEach((linkEle) => {
							linkEle.setAttribute("target", "_blank")
						})
					}
				})
		}
		return {
			onAnnotationLayerRender,
		}
	}

	const jumpToPagePlugin = () => {
		const store = React.useMemo(() => createStore(), [])

		return {
			install: (pluginFunctions) => {
				store.update("jumpToPage", pluginFunctions.jumpToPage)
			},
			jumpToPage: (pageIndex) => {
				const fn = store.get("jumpToPage")
				if (fn) {
					fn(pageIndex)
				}
			},
		}
	}

	const jumpToPagePluginInstance = jumpToPagePlugin()
	const customAnnotationPluginInstance = customAnnotationPlugin()
	const zoomPluginInstance = zoomPlugin()
	const toolbarPluginInstance = toolbarPlugin()
	const { jumpToPage } = jumpToPagePluginInstance
	const { CurrentScale, ZoomIn, ZoomOut } = zoomPluginInstance
	const { Toolbar } = toolbarPluginInstance
	const { CurrentPageLabel } = Toolbar
	const [isDocumentLoaded, setDocumentLoaded] = React.useState(false)
	const [notes, setNotes] = React.useState([])
	const [triggerAddAnnotation, setTriggerAddAnnotation] = React.useState({})
	const handleDocumentLoad = () => setDocumentLoaded(true)

	// useEffect(() => {
	// 	const params = location?.pathname?.split("/")
	// 	const fileId = params[params.length - 1]
	// 	axios
	// 		.get(`/file/downloadbase64/${fileId}`)
	// 		.then((response) => {
	// 			if (response?.data) {
	// 				setBase64(`data:application/pdf;base64,${response?.data}`)
	// 			} else {
	// 				setBase64("...")
	// 			}
	// 		})
	// 		.catch(() => {
	// 			setBase64("...")
	// 		})
	// }, [])

	const blobToBase64 = (blob) => {
		const reader = new FileReader()
		reader.readAsDataURL(blob)
		return new Promise((resolve) => {
			reader.onloadend = () => {
				resolve(reader.result)
			}
		})
	}

	useEffect(() => {
		const params = location?.pathname?.split("/")
		const fileId = params[params.length - 1]
		axios
			.get(`/file/download/${fileId}`, { responseType: "blob" })
			.then((response) => {
				if (response?.data) {
					const data = response.data
					const fileType = { type: "application/pdf" }
					const blob = new Blob([data], fileType)
					const url = URL.createObjectURL(blob)
					setBase64(url)
				} else {
					setBase64("...")
				}
			})
			.catch(() => {
				setBase64("...")
			})
	}, [documentDetails])

	useEffect(() => {
		if (annotations) {
			setNotes(annotations)
		}
	}, [annotations])

	const highlightContentOnPDF = () => {
		let highlightWords = []
		if (highlightFilter?.specificWord) {
			highlightWords = [...highlightWords, ...highlightFilter?.searchWord]
		}
		if (highlightFilter?.concepts) {
			highlightWords = [...highlightWords, ...highlightFilter?.loadedConcept]
		}
		if (highlightFilter?.dates && documentDetails?.metadata?.dates?.length > 0) {
			highlightWords = [...highlightWords, ...documentDetails?.metadata?.dates]
		}
		if (highlightFilter?.emails && documentDetails?.metadata?.emails?.length > 0) {
			highlightWords = [...highlightWords, ...documentDetails?.metadata?.emails]
		}
		if (highlightWords?.length) {
			setHighlightMultipleWords(highlightWords.flat())
		} else {
			setHighlightMultipleWords([" "])
		}
	}

	useEffect(() => {
		if (highlightMultipleWords) {
			highlight({
				keyword: `\\b(?:${highlightMultipleWords.join("|")})\\b`,
				matchCase: false,
				wholeWords: false,
			})
		}
	}, [highlightMultipleWords])

	useEffect(() => {
		highlightContentOnPDF()
	}, [highlightFilter])

	useEffect(() => {
		if (isDocumentLoaded) {
			highlightContentOnPDF()
		}
	}, [isDocumentLoaded])

	const renderLoader = () => (
		<div
			style={{
				alignItems: "center",
				display: "flex",
				height: "100%",
				justifyContent: "center",
			}}
		>
			<div
				style={{
					borderRadius: "0.25rem",
					padding: "0.5rem",
				}}
			>
				<CircularProgress />
			</div>
		</div>
	)
	const renderError = (error) => {
		let message = ""
		switch (error.name) {
			case "InvalidPDFException":
				message = t("nativeViewer.documentMissing")
				break
			case "MissingPDFException":
				message = t("nativeViewer.documentMissing")
				break
			case "UnexpectedResponseException":
				message = t("nativeViewer.unexpectedServerResponse")
				break
			default:
				message = t("nativeViewer.cannotLoadDocument")
				break
		}

		return (
			<div
				style={{
					alignItems: "center",
					display: "flex",
					height: "100%",
					justifyContent: "center",
				}}
			>
				<div
					style={{
						borderRadius: "0.25rem",
						padding: "0.5rem",
					}}
				>
					{message}
				</div>
			</div>
		)
	}

	useEffect(() => {
		jumpToPage(currentPageNumber - 1)
	}, [currentPageNumber])

	const renderHighlightTarget = (props) => {
		let noteId = notes.length
		const params = location?.pathname?.split("/")
		const fileId = params[params.length - 1]
		if (annotationStatus) {
			props.toggle()
			const note = {
				file_id: fileId,
				page_number: document.querySelector('[data-testid="page-navigation__current-page-input"]')?.value,
				id: ++noteId,
				content: "",
				highlightAreas: props.highlightAreas,
				quote: props.selectedText,
			}
			const payload = {
				note,
				isNative: true,
			}
			setTriggerAddAnnotation(payload)
			props.cancel()
		}
		return <></>
	}

	useEffect(() => {
		if (!_.isEmpty(triggerAddAnnotation)) {
			dispatch(addAnnotation(triggerAddAnnotation))
			setTriggerAddAnnotation({})
		}
	}, [triggerAddAnnotation])

	const renderHighlights = (props) => (
		<div>
			{Array.isArray(notes) &&
				notes?.map((note) => (
					<React.Fragment key={note.id}>
						{note.highlightAreas
							.filter((area) => area.pageIndex === props.pageIndex)
							.map((area, idx) => (
								<div
									key={idx}
									style={Object.assign(
										{},
										{
											background: "green",
											opacity: 0.4,
										},
										props.getCssProperties(area, props.rotation)
									)}
								/>
							))}
					</React.Fragment>
				))}
		</div>
	)

	const highlightPluginInstance = highlightPlugin({
		renderHighlightTarget,
		renderHighlights,
	})

	return (
		<>
			<NativeHeader
				Toolbar={Toolbar}
				jumpToNextMatch={jumpToNextMatch}
				jumpToPreviousMatch={jumpToPreviousMatch}
				isNativeformatHeader={true}
				annotationStatus={annotationStatus}
				retainedFilterJobData={props?.retainedFilterJobData}
			/>
			<Box className={classes.root}>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						height: "100%",
					}}
				>
					<div
						style={{
							flex: 1,
							overflow: "hidden",
							display: base64 ? "flex" : "table",
						}}
					>
						{base64 ? (
							<Worker workerUrl="/pdf.worker.js">
								<Viewer
									fileUrl={base64}
									plugins={[
										zoomPluginInstance,
										toolbarPluginInstance,
										customAnnotationPluginInstance,
										jumpToPagePluginInstance,
										searchPluginInstance,
										highlightPluginInstance,
									]}
									renderLoader={renderLoader}
									onDocumentLoad={handleDocumentLoad}
									renderError={renderError}
									initialPage={currentPageNumber - 1}
								/>
							</Worker>
						) : (
							<div
								style={{
									display: "table-cell",
									textAlign: "center",
									verticalAlign: "middle",
								}}
							>
								<div
									style={{
										alignItems: "center",
										display: "flex",
										justifyContent: "center",
									}}
								>
									<div
										style={{
											borderRadius: "0.25rem",
											padding: "0.5rem",
										}}
									>
										<CircularProgress />
									</div>
								</div>
								{documentDetails?.size >= 300000000 && (
									<div
										style={{
											alignItems: "center",
											display: "flex",

											justifyContent: "center",
										}}
									>
										<div
											style={{
												borderRadius: "0.25rem",
												padding: "0.5rem",
											}}
										>
											<div>{t("largerFile")}</div>
										</div>
									</div>
								)}
							</div>
						)}
					</div>
				</div>
			</Box>
		</>
	)
}

export default NativeView
